#import "../fragments/product-category-fragment.graphql"

query GetProductsCategories {
    productCategories {
        ...ProductCategoryFragment
    }
}
